import { Component, EventEmitter, Inject, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MotivationFullDetails, TextPartData } from 'src/app/all-motivations/model/all-motivations.interface';
import { MotivationsService } from '../../services/motivation/motivations.service';
import { Input } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { PersonalUserDataService } from '../../services/personal-user-data/personal-user-data.service';
import { AbstractMotivationsService } from '../../services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-motivation-view',
  templateUrl: './motivation-view.component.html',
  styleUrls: ['./motivation-view.component.scss']
})
export class MotivationViewComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  motivationDetails : MotivationFullDetails | undefined;
  imageRootFolder = 'assets/motivations/';
  descriptionTextParts: TextPartData[];
  @Input() selectedMotivationId = "";
  @Input() showClose: boolean = false;
  @Input() showVideo: boolean = true;
  @Output() closeSideNavEvent = new EventEmitter();

  constructor(private readonly motivationsService: AbstractMotivationsService, personalUserDataService: PersonalUserDataService) {
    super();
    this.motivationDetails;
    this.descriptionTextParts = []; 
   }

  ngOnChanges(changes: SimpleChanges): void {
    
    this.ifChanged(changes.selectedMotivationId, () => {
      if (this.selectedMotivationId === ""){
            this.motivationDetails = undefined;
          }
          else{
            this.getMotivation(this.selectedMotivationId);
        }
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    // console.log('motivationBiewComp id is'+this.data.id);
  }

  getMotivation(id:string):void{
    console.log(`trying to fetch motivation with id ${id}`)
    this.motivationsService.getMotivation(id).subscribe(motivationDetails => {
      // console.log(`motivationDetails=${JSON.stringify(motivationDetails)}`);

      if (motivationDetails == undefined){
        return;
      }

      this.motivationDetails = motivationDetails;

      if ( this.motivationDetails.longDescriptionPlural == undefined){
        return;
      }

      const descriptionLines = this.motivationDetails.longDescriptionPlural.split("\n");

      this.descriptionTextParts = [];
      
      for (let currLine of descriptionLines){
        let textData = new TextPartData();

        if (currLine.includes('**')){
          // this is a header
          textData.isHeader = true;
          textData.text = currLine.replace(/\*\*/g, '');
        }
        else{
          textData.isHeader = false;
          textData.text = currLine;
        }

        this.descriptionTextParts.push(textData);
      }
    })
  }
  
  closeSideNav(){
    this.closeSideNavEvent.emit();
  }
} 
